import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../Context';
import { motion } from 'framer-motion';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const Checkout = () => {
	const { psServer, packageChoice, submittedCode, setIsLoading, paymentGateway, setPaymentID, clickedImage } = useAppContext();
	
	/*	Paypal stuff*/
	/*
	const initialOptions = {
		"client-id": "test",
		"enable-funding": "venmo",
		"disable-funding": "",
		"buyer-country": "GB",
		currency: "GBP",
		"data-page-type": "product-details",
		components: "buttons",
		"data-sdk-integration-source": "developer-studio",
	};
	const [message, setMessage] = useState("");
	function Message({ content }) {
		return <p>{content}</p>;
	}
	const PaypalBoxRender = () => {
		return (
			<>
				<PayPalScriptProvider options={initialOptions}>
					<PayPalButtons
					   style={{
							shape: "pill",
							layout: "vertical",
							color: "blue",
							label: "paypal",
						}}
					   createOrder={async () => {
							try {
								const response = await fetch(psServer + `/payment/start`, {
									method: "POST",
									headers: {
										"Content-type": "application/json",
									},
									body: JSON.stringify({
										submittedCode: submittedCode,
										packageChoice: packageChoice
									})
								});
								const orderData = await response.json();
								
								if (orderData.gatewayResponse.id) {
									return orderData.gatewayResponse.id;
								} else {
									const errorDetail = orderData?.gatewayResponse?.details?.[0];
									const errorMessage = errorDetail
										? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
										: JSON.stringify(orderData);
									throw new Error(errorMessage);
								}
							} catch (error) {
								console.error(error);
								setMessage(
									`Could not initiate PayPal Checkout...${error}`
								);
							}
						}}
					   onApprove={async (data, actions) => {
							try {
								const response = await fetch(
									`/api/orders/${data.orderID}/capture`,
									{
										method: "POST",
										headers: {
											"Content-Type": "application/json",
										},
									}
								);
								const orderData = await response.json();
								// Three cases to handle:
								//   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
								//   (2) Other non-recoverable errors -> Show a failure message
								//   (3) Successful transaction -> Show confirmation or thank you message
								const errorDetail = orderData?.details?.[0];
								if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
									// (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
									// recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
									return actions.restart();
								} else if (errorDetail) {
									// (2) Other non-recoverable errors -> Show a failure message
									throw new Error(
										`${errorDetail.description} (${orderData.debug_id})`
									);
								} else {
									// (3) Successful transaction -> Show confirmation or thank you message
									// Or go to another URL:  actions.redirect('thank_you.html');
									const transaction =
										orderData.purchase_units[0].payments
											.captures[0];
									setMessage(
										`Transaction ${transaction.status}: ${transaction.id}. See console for all available details`
									);
									console.log(
										"Capture result",
										orderData,
										JSON.stringify(orderData, null, 2)
									);
								}
							} catch (error) {
								console.error(error);
								setMessage(
									`Sorry, your transaction could not be processed...${error}`
								);
							}
						}}
					/>
				</PayPalScriptProvider>
				<Message content={message} />
			</>
		);
	};
	*/
	/*	Paypal stuff*/
	
	const navigate = useNavigate();
	const [middleMessage, setMiddleMessage] = useState('Please wait...');
	const [paymentFailed, setPaymentFailed] = useState(false);
	
	const getPaymentLink = async() => {
		setIsLoading(true);
		const response = await fetch(psServer + `/payment/start`, {
			method: "POST",
			headers: {
				"Content-type": "application/json",
			},
			body: JSON.stringify({
				submittedCode: submittedCode,
				packageChoice: packageChoice,
				clickedImage: clickedImage
			})
		});
		const data = await response.json();
		if (!data?.gatewayResponse) {
			setIsLoading(false);
			navigate('/');
			return;
		}
		if (!data?.gatewayResponse?.id) {
			setIsLoading(false);
			navigate('/');
			return;
		}
		setPaymentID(data.gatewayResponse.id);
		data.status === "success" ? window.location.href = data.gatewayResponse.url : setPaymentFailed(true);
		setIsLoading(false);
	};
	
	useEffect(() => {
		if (paymentFailed) {
			setMiddleMessage('Payment Failed');
			var navigateTo = `/?qr=${submittedCode}`;
			if (submittedCode === null) {
				navigateTo = '/';
			}
			setTimeout(function(){navigate(navigateTo)}, 5000);
		}
	},[paymentFailed]);
	
	useEffect(() => {
		/*
		if (paymentGateway !== "paypal") {
			getPaymentLink();
		}
		*/
		getPaymentLink();
	},[]);
	
	return (
		<div className="landing">
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 1, ease: 'easeInOut' }}
				style={{width: '100%', maxWidth: '600px'}}
			>
				{middleMessage}
				{/*
				{paymentGateway === "paypal" ? (
					<PaypalBoxRender />
				) : (
					{middleMessage}
				)}
				*/}
			</motion.div>
		</div>
	);
};

export default Checkout;